import React from 'react';
import { Button } from './ui/Button';
interface OverviewTabProps {
  onNavigate: (tabId: string) => void;
}
export function OverviewTab({
  onNavigate
}: OverviewTabProps) {
  return <div className="flex flex-col items-center justify-center text-center py-16 md:py-24 px-4 animate-in fade-in duration-500" data-id="element-254">
      <div className="max-w-3xl space-y-8" data-id="element-255">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-gray-900" data-id="element-256">
          Every AI Action Has a Paper Trail
        </h1>

        <div className="space-y-4" data-id="element-257">
          <p className="text-xl md:text-2xl font-medium text-gray-700" data-id="element-258">
            MCPGuard enforces delegated authorization with full-chain
            auditability.
          </p>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-259">
            AI agents act on behalf of humans — under policy, with proof.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-8" data-id="element-260">
          <Button size="lg" onClick={() => onNavigate('early-access')} className="w-full sm:w-auto min-w-[200px]" data-id="element-261">
            Join the Waiting List
          </Button>
          <Button variant="outline" size="lg" onClick={() => onNavigate('early-access')} className="w-full sm:w-auto min-w-[200px]" data-id="element-262">
            Contact Us
          </Button>
        </div>
      </div>
    </div>;
}